/* eslint-disable max-len */

import {
  CommercialLink,
  SearchUserProfileResponse,
} from '@1po/1po-bff-fe-spec/generated/user/response/SearchUserProfileResponse';
import { AnyAction } from 'redux';
import { TradingProfile, User, UserProfile, UserRole } from 'domains/user';
import { documentLanguages, Language, webLanguages } from 'utils/i18n/Language';

export const mapTradingProfile = (
  user: User,
  commercialLink?: CommercialLink | null,
  delegatedCommercialLink?: CommercialLink | null,
): TradingProfile => {
  const currentCommercialLink = delegatedCommercialLink ?? commercialLink;
  const repository =
    currentCommercialLink?.repository ?? user.selectedProfile?.repository ?? user.repository ?? 'TRESOR';
  // Prefer repository-native IDs (BIR → birCode, TRESOR → tresorCode), with cross-fallback.
  const buyerId =
    repository === 'BIR'
      ? currentCommercialLink?.birCode ?? currentCommercialLink?.tresorCode ?? ''
      : currentCommercialLink?.tresorCode ?? currentCommercialLink?.birCode ?? '';
  const sellerId =
    repository === 'BIR'
      ? currentCommercialLink?.seller?.birCode ?? currentCommercialLink?.seller?.tresorCode
      : currentCommercialLink?.seller?.tresorCode ?? currentCommercialLink?.seller?.birCode;
  return new TradingProfile(buyerId, sellerId, repository);
};

export function mapUserProfileResponse(action: AnyAction): UserProfile | undefined {
  const response: SearchUserProfileResponse = action.payload;
  if (!response) {
    return undefined;
  }

  const {
    webLanguage,
    documentLanguage,
    documentLanguageFallback,
    commercialLink,
    userNotificationSettings,
  } = response;
  return {
    webLanguage: webLanguage ? Language.findByKey(webLanguages, webLanguage) : undefined,
    documentLanguage: documentLanguage ? Language.findByKey(documentLanguages, documentLanguage) : undefined,
    documentLanguageFallback: documentLanguageFallback
      ? Language.findByKey(documentLanguages, documentLanguageFallback)
      : undefined,
    commercialLink,
    userNotificationSettings,
  };
}

const isValidRole = (role: string): role is UserRole => Object.values(UserRole).includes(role as UserRole);

export const mapRoles = (roles: string[]): UserRole[] =>
  roles.filter((role) => isValidRole(role)).map((role) => role as UserRole);

const isUserAttributeInvalid = (attibute: string | string[] | undefined) => {
  return attibute === undefined || attibute.length === 0;
};

export const isUserTokenInvalid = (user?: User): boolean => {
  return (
    !user ||
    isUserAttributeInvalid(user.id) ||
    isUserAttributeInvalid(user.country) ||
    isUserAttributeInvalid(user.rights)
  );
};
